import React, { useState } from 'react';
import Button from '../../../button';
import ButtonSelect from '../../../button-select';
import CloseSVG from '../../../../assets/svg/close.svg';
import Modal from '../../modal';
import BulkAddCustomers from './add-bulk-customer';
import AddCustomer from './add-customer';

function SelectCustomerOption({ isOpen, closeModal, refresh }) {
  const [option, setOption] = useState('single');
  const [showAddCustomer, setShowAddCustomer] = useState(false);
  const [showAddBulkCustomers, setShowAddBulkCustomers] = useState(false);

  function submit() {
    if (option === 'single') {
      setShowAddCustomer(true);
    } else if (option === 'bulk') {
      setShowAddBulkCustomers(true);
    }
  }
  return (
    <>
      {showAddCustomer ? (
        <AddCustomer
          isOpen={showAddCustomer}
          closeModal={() => {
            setShowAddCustomer(false);
          }}
          completed={() => {
            setShowAddCustomer(false);
            closeModal();
          }}
          vendorData={null}
          title='Add Customer'
          buttonText='Save '
        />
      ) : null}

      <BulkAddCustomers
        isOpen={showAddBulkCustomers}
        closeModal={() => setShowAddBulkCustomers(false)}
        completed={() => {
          setShowAddBulkCustomers(false);
          closeModal();
        }}
      />

      <Modal
        scrollable={true}
        className='!md:max-w-[600px] max-w-full !rounded-none'
        isOpen={isOpen}
        centered={true}
      >
        <div className='flex flex-col overflow-auto'>
          <div className='pl-8 pr-8 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Add Customers</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col items-center w-full'>
            <span className='text-[15px] -mb-3'>
              Select your desired option to add customers
            </span>
            <div className='flex flex-col justify-center h-full min-h-[400px] max-w-[85%] w-full'>
              <ButtonSelect
                title={'Add Single Customer'}
                subtitle={'Add Customers one after the other'}
                isActive={option === 'single'}
                onClick={() => setOption('single')}
              />

              <ButtonSelect
                title={'Import Customer information'}
                subtitle={
                  'Import Customers using a pre-defined XLSX template'
                }
                isActive={option === 'bulk'}
                onClick={() => setOption('bulk')}
                className='mt-8'
              />

              <div className='w-full mt-[20px]'>
                <Button text='NEXT' type='submit' onClick={() => submit()} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SelectCustomerOption;
